import { memo } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { styled } from '@mui/material'
import { ProgramManagementRow } from '../programManagement'

export const ProgramItemTreeCellRenderer = memo(
  (props: ICellRendererParams<ProgramManagementRow>) => {
    const { value, data } = props
    return (
      <Root>
        {data?.iconUrl && <Icon src={data.iconUrl} />}
        <Label>{value}</Label>
      </Root>
    )
  },
  (prevProps, nextProps) => {
    if (prevProps.value !== nextProps.value) return false
    if (prevProps.data?.iconUrl !== nextProps.data?.iconUrl) return false
    return true
  }
)

const Root = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  overflow: 'hidden',
})

const Icon = styled('img')({
  width: 20,
  height: 20,
  flexShrink: 0,
})

const Label = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})
